import InvitarAmigos from './InvitarAmigos';
export default InvitarAmigos ;
